import { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import ComplinaceOpen from 'features/components/compliance/ComplinaceOpen';
import ComplinaceCompleted from 'features/components/compliance/ComplinaceCompleted';
import ComplinaceClosed from 'features/components/compliance/ComplinaceClosed';

export class ComplianceRouter extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Switch>
                <Route exact path={`/compliance/open`} component={ComplinaceOpen} />
                <Route exact path={`/compliance/completed`} component={ComplinaceCompleted} />
                <Route exact path={`/compliance/closed`} component={ComplinaceClosed} />
  
            </Switch>
        );
    }
}
